"use strict";
/*
 * PHPConfig - Loads Uniter's PHP configuration
 * Copyright (c) Dan Phillimore (asmblah)
 * https://github.com/uniter/phpconfig/
 *
 * Released under the MIT license
 * https://github.com/uniter/phpconfig/raw/master/MIT-LICENSE.txt
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @inheritDoc
 */
var SerialisationChecker = /** @class */ (function () {
    function SerialisationChecker() {
    }
    /**
     * @inheritDoc
     */
    SerialisationChecker.prototype.isSerialisable = function (object) {
        return this.isObjectSerialisable(object);
    };
    SerialisationChecker.prototype.isObjectSerialisable = function (object, objectsSeen) {
        if (objectsSeen === void 0) { objectsSeen = []; }
        if (objectsSeen.includes(object)) {
            return false;
        }
        objectsSeen = objectsSeen.concat([object]);
        if (object instanceof Function || object instanceof RegExp) {
            return false;
        }
        if (Array.isArray(object)) {
            for (var _i = 0, object_1 = object; _i < object_1.length; _i++) {
                var element = object_1[_i];
                if (!this.isValueSerialisable(element, objectsSeen)) {
                    return false;
                }
            }
        }
        for (var _a = 0, _b = Object.keys(object); _a < _b.length; _a++) {
            var settingName = _b[_a];
            if (!this.isValueSerialisable(object[settingName], objectsSeen)) {
                return false;
            }
        }
        return true;
    };
    SerialisationChecker.prototype.isValueSerialisable = function (value, objectsSeen) {
        if (objectsSeen === void 0) { objectsSeen = []; }
        if (value == null ||
            typeof value === 'boolean' ||
            typeof value === 'number' ||
            typeof value === 'string') {
            return true;
        }
        if (typeof value === 'object') {
            return this.isObjectSerialisable(value, objectsSeen);
        }
        return false;
    };
    return SerialisationChecker;
}());
exports.default = SerialisationChecker;
//# sourceMappingURL=SerialisationChecker.js.map